import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';

@Injectable()
export class ValidationEmailService {
  protected path = 'sendvalidationemail';
  constructor(private httpService: HttpService) {}

  public sendValidationEmail(): Observable<void> {
    return this.httpService.makePost<void, void>(this.path, null);
  }
}
